import Note from './Note';
export { default as NotePage } from './NotePage';
export default Note;
